import { Autocomplete, TextField } from "@mui/material";
import { useMemo } from "react";
import { useAppData, type Project } from "store/appData";
import t from "./translations";

type Props = {
  region: string;
  value: number | null;
  onChange: (projectId: number | null) => void;
};

export default function ProjectPicker({ region, value, onChange }: Props) {
  const { projects: projectsById } = useAppData();

  const projects = useMemo(
    () => Object.values(projectsById).filter((project) => project.region === region),
    [projectsById, region]
  );

  const selected = projects.find((project) => project.id === value) ?? null;

  return (
    <Autocomplete<Project>
      options={projects}
      value={selected}
      onChange={(_event, next) => onChange(next?.id ?? null)}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, current) => option.id === current.id}
      renderInput={(params) => (
        <TextField {...params} label={t.CustomerLabel} />
      )}
    />
  );
}
